export const NAV = [
  { label: "About", href: "#about" },
  { label: "Academics", href: "#academics" },
  { label: "Admissions", href: "#admissions" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Rooted in Tradition",
    body:
      "We begin each day grounded in the timeless wisdom of Indian culture — Sanskrit shlokas, yoga, classical arts and the values of discipline, gratitude and reverence. Character is the first subject we teach.",
  },
  {
    no: "02",
    title: "Fluent in the Modern",
    body:
      "Bright classrooms, science and computer labs, and inquiry-led learning prepare every child for a fast-changing world. Curiosity is nurtured through experiment, technology and open dialogue.",
  },
  {
    no: "03",
    title: "One Complete Child",
    body:
      "From Primary to Secondary, we shape heart and intellect together — where a student can chant a mantra at dawn and code a program by noon. This wholeness is the promise of Bhakti Svarup Vidya Niketan.",
  },
];

export const PROGRAMS = [
  {
    stage: "Primary",
    grades: "Nursery – Class 5",
    text:
      "A joyful foundation. Play-based, activity-rich learning in language, numeracy, art and values that lets young minds fall in love with school.",
  },
  {
    stage: "Middle",
    grades: "Class 6 – Class 8",
    text:
      "Concepts deepen. Students explore science, mathematics, languages and Indian heritage through projects, labs and hands-on discovery.",
  },
  {
    stage: "Secondary",
    grades: "Class 9 – Class 10",
    text:
      "Focus and mastery. Rigorous academics paired with mentorship, board preparation and life-skills that ready students for what comes next.",
  },
];

export const STATS = [
  { value: "500+", label: "Students" },
  { value: "20+", label: "Educators" },
  { value: "5", label: "Acre Campus" },
  { value: "100%", label: "Board Results" },
];

export const GALLERY = [
  { src: "/gallery/p8.jpg", alt: "B.S.V.N Gurukul Entrance", arch: false, span: "" },
  { src: "/gallery/p9.jpg", alt: "8th Annual Function Celebration", arch: true, span: "row-span-2" },
  { src: "/gallery/p7.jpg", alt: "March-Past on Sports Day", arch: false, span: "" },
  { src: "/gallery/p1.jpg", alt: "Cultural Day Celebrations", arch: false, span: "" },
  { src: "/gallery/p4.jpg", alt: "Recognising Excellence", arch: true, span: "row-span-2" },
  { src: "/gallery/p2.jpg", alt: "Annual Sports Meet", arch: false, span: "" },
  { src: "/gallery/p5.jpg", alt: "Morning Assembly", arch: false, span: "" },
  { src: "/gallery/p3.jpg", alt: "Focused Learning", arch: false, span: "" },
];

export const IMG = {
  traditional: "/gallery/p4.jpg",
  modern: "/gallery/p3.jpg",
};
